<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn
          color="darkColor"
          small
          ref="yes"
          rounded
          class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white"
          @click="confirmDialogConfirmFunction()"
          :disabled="disabelConfirm"
        >
          بله
        </v-btn>
        <v-btn
          small
          rounded
          text
          ref="no"
          class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()"
        >
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">سوالات عمومی</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2 mt-3">
            <v-col cols="12">
              <v-card height="73vh" elevation="0" class="body-card card-width">
                <v-card-text>
                  <v-row>
                    <v-col cols="7" class="body-card">
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            type="text"
                            dense
                            clearable
                            v-model="triageAnswer.title"
                            :autofocus="true"
                            clear-icon="mdi-close-circle-outline"
                            outlined
                            v-on:keyup.enter="showConfirmDialogFunction()"
                            label="پاسخ*"
                            class="input-label"
                            prepend-inner-icon="mdi-text-box mdi-18px"
                            tabindex="1"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-autocomplete
                            :items="triageRankItems"
                            no-data-text="اطلاعاتی وجود ندارد"
                            tabindex="2"
                            dense
                            v-model="triageAnswer.rank"
                            outlined
                            clearable
                            clear-icon="mdi-close-circle-outline"
                            item-text="title"
                            item-value="id"
                            label="سطح"
                            autocomplete="off"
                            prepend-inner-icon="mdi-alarm-light mdi-18px"
                            style="font-size: 11px !important"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            type="text"
                            label="مشاوره"
                            auto-grow
                            v-model="triageAnswer.hint"
                            outlined
                            dense
                            v-on:keyup.enter="showConfirmDialogFunction()"
                            clearable
                            clear-icon="mdi-close-circle-outline"
                            rows="4"
                            class="input-label"
                            prepend-inner-icon="mdi-script-text mdi-18px"
                            tabindex="3"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12">
                          <v-card elevation="0" class="go-to-another-complaint-card">
                            <v-card-text v-if="isOpenGoTo == false">
                              <v-row no-gutters>
                                <v-icon color="#49454F">mdi-arrow-top-left-bold-box</v-icon>
                                <span class="mr-2 go-to-another-complaint-card-close-text">
                                  ارجاع به:
                                </span>
                                <span
                                  v-if="selectedGoTo"
                                  class="go-to-another-complaint-card-close-text-cotent"
                                >
                                  {{ selectedGoTo.title }}
                                </span>
                                <v-spacer></v-spacer>
                                <v-icon color="#49454F" @click="goToOpenClose(1)">
                                  mdi-chevron-down
                                </v-icon>
                              </v-row>
                            </v-card-text>
                            <v-card-text v-if="isOpenGoTo == true">
                              <v-row no-gutters>
                                <v-icon color="#49454F" class="mt-n10">
                                  mdi-arrow-top-left-bold-box
                                </v-icon>
                                <span class="mr-2 go-to-another-complaint-card-close-text">
                                  ارجاع به:
                                </span>
                                <v-spacer></v-spacer>
                                <v-col cols="6">
                                  <v-text-field
                                    dense
                                    rounded
                                    filled
                                    placeholder="جستجو..."
                                    append-icon="mdi-magnify"
                                    v-model="searchGoToText"
                                  ></v-text-field>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="2">
                                  <v-btn
                                    @click="selectGoToItem(null)"
                                    rounded
                                    outlined
                                    class="normal-letter-spacing"
                                    color="darkColor"
                                    block
                                  >
                                    <v-icon>mdi-close</v-icon>
                                    هیچکدام
                                  </v-btn>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-icon color="#49454F" @click="goToOpenClose(2)" class="mt-n10">
                                  mdi-chevron-up
                                </v-icon>
                              </v-row>
                              <v-row>
                                <v-chip
                                  :class="item.class"
                                  @click="selectGoToItem(item)"
                                  label
                                  v-for="item in goToFilteredList"
                                  :key="item.id"
                                >
                                  {{ item.code }}
                                  <hr class="go-to-another-complaint-card-divider" />
                                  {{ item.title }}
                                </v-chip>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" v-if="showGoToQuetion">
                          <v-card elevation="0" class="go-to-another-complaint-card">
                            <v-card-text v-if="isOpenGoToQuestion == false">
                              <v-row no-gutters>
                                <v-icon color="#49454F">mdi-arrow-top-left-bold-box</v-icon>
                                <span class="mr-2 go-to-another-complaint-card-close-text">
                                  سوالات:
                                </span>
                                <span
                                  v-if="selectedGoTo"
                                  class="go-to-another-complaint-card-close-text-cotent"
                                >
                                  {{ selectedGoTo.title }}
                                </span>
                                <v-spacer></v-spacer>
                                <v-icon color="#49454F" @click="goToQuestionOpenClose(1)">
                                  mdi-chevron-down
                                </v-icon>
                              </v-row>
                            </v-card-text>
                            <v-card-text v-if="isOpenGoToQuestion == true">
                              <v-row no-gutters>
                                <v-icon color="#49454F" class="mt-n10">
                                  mdi-arrow-top-left-bold-box
                                </v-icon>
                                <span class="mr-2 go-to-another-complaint-card-close-text">
                                  سوالات:
                                </span>
                                <v-spacer></v-spacer>
                                <v-col cols="6">
                                  <v-text-field
                                    dense
                                    rounded
                                    filled
                                    placeholder="جستجو..."
                                    append-icon="mdi-magnify"
                                    v-model="searchGoToQuestionText"
                                  ></v-text-field>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="2">
                                  <v-btn
                                    @click="selectGoToQuestionItem(null)"
                                    rounded
                                    outlined
                                    class="normal-letter-spacing"
                                    color="darkColor"
                                    block
                                  >
                                    <v-icon>mdi-close</v-icon>
                                    هیچکدام
                                  </v-btn>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-icon
                                  color="#49454F"
                                  @click="goToQuestionOpenClose(2)"
                                  class="mt-n10"
                                >
                                  mdi-chevron-up
                                </v-icon>
                              </v-row>
                              <v-row>
                                <v-chip
                                  :class="item.class"
                                  @click="selectGoToQuestionItem(item)"
                                  label
                                  v-for="(item, index) in goToQuestionFilteredList"
                                  :key="item.id"
                                >
                                  {{ index + 1 }}
                                  <hr class="go-to-another-complaint-card-divider" />
                                  {{ item.title }}
                                </v-chip>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" class="mt-6">
                          <v-row>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="darkColor"
                              @click="showConfirmDialogFunction()"
                              dark
                              rounded
                              class="normal-letter-spacing px-12 ml-6"
                            >
                              ثبت
                            </v-btn>
                            <v-btn
                              rounded
                              color="darkColor"
                              outlined
                              @click="cancelAddTriageAnswer()"
                              class="normal-letter-spacing px-10"
                            >
                              انصراف
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="5">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="question-title">{{ questionTitle }}</span>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-16">
                        <v-col cols="12" class="mt-8">
                          <v-img :src="triageAnwerIMG"></v-img>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component
      ref="snackRef"
      :snakTimeOut="snakTimeOut"
      :snackColor="snackColor"
      :snackText="snackText"
      :snakIcon="snakIcon"
    ></alert-component>
  </div>
</template>
<script>
  import AlertComponent from '../../components/AlertComponent.vue';
  import confirmDialog from '../../components/ConfirmDialog.vue';

  import snackBar from '@/Mixins/snackBar.js';
  import ShearedMixin from '@/Mixins/Shared.js';
  import ShearedHelper from '@/Helpers/Shared.js';
  import AddTriageAnswer from '@/Helpers/Triage/AddTriageAnswerHelper.js';
  import ChiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';
  import TriageQuestionMixin from '@/Mixins/Triage/TriageQuestionMixin.js';
  import TriageAnswerMixin from '@/Mixins/Triage/TriageAnswerMixin.js';
  export default {
    name: 'TriageAnswerManagment',
    title: 'سوالات عمومی',
    inject: ['load', 'tableImg', 'tableTitleImage'],
    components: {
      AlertComponent,
      confirmDialog,
    },
    mixins: [
      ShearedMixin,
      ShearedHelper,
      snackBar,
      AddTriageAnswer,
      ChiefComplaintMixin,
      TriageQuestionMixin,
      TriageAnswerMixin,
    ],
    created() {
      this.$root.$refs.TriageAnswerManagment = this;
    },
    mounted() {
      this.mounteLoding();
    },
    data() {
      return {
        triageAnwerIMG: require('@/assets/images/TriageAnwer.png'),
      };
    },
    methods: {
      mounte: function () {
        let route = this.$route.params.id;
        let routeInfo = route.split('-');
        if (routeInfo[1] == 1) {
          this.isAdd = true;
        } else if (routeInfo[1] == 2) {
          this.isAdd = false;
        }
        this.answerId = Number(routeInfo[2]);
        this.getListOfChiefComplaintsForOther();
        this.questionId = Number(routeInfo[0]);
        this.questionTitle = localStorage.getItem('qTitle');
      },
    },
    computed: {
      goToFilteredList() {
        return this.allChiefComplaintsForOther.filter((u) => {
          return u.title.includes(this.searchGoToText) || u.code.includes(this.searchGoToText);
        });
      },
      goToQuestionFilteredList() {
        return this.allTriageQuestions.filter((u) => {
          return u.title.includes(this.searchGoToQuestionText);
        });
      },
    },
  };
</script>
<style scoped>
  .confirm-cancel-btn {
    border: solid 1px var(--dark-color);
    padding-top: 13px;
    padding-bottom: 15px;
    color: var(--dark-color);
  }
  .body-card {
    overflow-y: auto !important;
    height: 78vh !important;
  }
  .go-to-another-complaint-card {
    border: 1px solid #79747e !important;
  }
  .go-to-another-complaint-card-close-text {
    font-size: 14px;
    margin-top: 2px !important;
    font-weight: 400;
    color: #49454f !important;
  }
  .go-to-another-complaint-card-divider {
    border-top: none;
    border-bottom: none;
    border-right: 2px solid white !important;
    border-left: none;
    height: 18px !important;
    width: 0px !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  >>> .selected-go-to-item {
    background: var(--dark-color) !important;
    color: white !important;
  }
  .go-to-another-complaint-card-close-text-cotent {
    color: var(--dark-color);
    font-weight: 500;
    font-size: 14px;
    margin-top: 2px !important;
    margin-right: 10px !important;
  }
  .question-title {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    border-radius: 10px !important;
    background: #d0e6ff !important;
  }

  @media only screen and (min-width: 1280px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1366px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 98.5% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 1vh !important;
    }
  }
</style>
